// eslint-disable-next-line import/prefer-default-export
export function isShippingAvailableForCountry(country) {
    const { shipping_available: shippingAvailable } = country;
    return Boolean(shippingAvailable);
}
